import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/estado-notificacions`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/estado-notificacions/${id}?populate=*`, options)
    .then((response) => {
      let tag = jsona.deserialize(response.data);
      delete tag.links;
      return tag;
    });
}

function add(estado) {
  console.log(estado);
  var payload = { data: estado };
  /*  const payload = jsona.serialize({
    stuff: tipo,
    includeNames: null,
  }); */

  console.log(payload);

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/estado-notificacions`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(estado) {
  console.log(estado);
  var payload = { data: estado };

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .put(`${url}/estado-notificacions/${estado.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/estado-notificacions/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
